// extracted by mini-css-extract-plugin
module.exports = {"lia-badge-unearned":"FeaturedBadgesList_lia-badge-unearned__aTa9r","lia-badge":"FeaturedBadgesList_lia-badge__OwOtU"};